<template>
    <div class="siderbar-box" @click="hidePop" v-if="sidebarShow">
        <div class="shadow-box sm:hidden" v-if="sidebarShow" @click="hideSiderbarBox"></div>
        <div
            class="siderbar-body smooth-transition"
            :class="{ '-left-full': !sidebarShow }"
        >
        <!--收起按钮-->
        <div class="closeSiderbarBtn" v-if="sidebarShow"  @click="hideSiderbarBox">
            <img src="@/assets/icon_cancel.png" />
        </div>
            <!-- <div class="max-sm:hidden self-start cursor-pointer py-1" @click="openAI(0)">
                <img src="@/assets/logo.png" />
            </div> -->
            <!--PC端才有操作指引和历史会话的tab栏,左侧栏选择AI聊天时没有tab栏,没有操作指引-->
            <!-- <div class="max-sm:hidden"  v-if="currentTool.show_title">
                <div class="guide-history-top">
                    <div class="guide-btn" :class="{active:currentTab==='guide'}" @click="currentTab='guide'">操作指引</div>
                    <div class="guide-btn" :class="{active:currentTab==='history'}" @click="currentTab='history'">历史会话</div>
                </div>
            </div>
            
            <div class="new-chat max-sm:hidden !mt-0 blue-new-chat">
                <el-button :plain="true" class="new-chat-text" @click="addChat('')">新会话</el-button>
            </div> -->

            <!--PC端才有操作指引和历史会话的内容-->
            <div class="max-sm:hidden">
                <!-- <template v-if="currentTool.show_title">
                    <div v-show="currentTab==='guide'" class="guide-cont">
                        <div class="guide-title">{{currentTool.show_title}}</div>
                        <div class="guide-step-list">
                            <div class="guide-step">
                                <div class="step-icon"></div>
                                <div class="step-cont">
                                    <div class="step-title">第一步 <label>01</label></div>
                                    <p class="guide-text">{{currentTool.show1}}</p>
                                </div>
                            </div>
                            <div class="guide-step">
                                <div class="step-icon"></div>
                                <div class="step-cont">
                                    <div class="step-title">第二步 <label>02</label></div>
                                    <p class="guide-text">{{currentTool.show2}}</p>
                                </div>
                            </div>
                            <div class="guide-step" v-if="currentTool.show3">
                                <div class="step-icon"></div>
                                <div class="step-cont">
                                    <div class="step-title">第三步 <label>03</label></div>
                                    <p class="guide-text">{{currentTool.show3}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </template> -->
                <!--currentTab==='history'或者左侧栏选择的AI聊天时,显示历史会话-->
                <!-- v-show="currentTab==='history'"-->
                <div class="history-cont">
                    <div class="history-chat-box">
                        <p class="history-chat">历史会话</p>
                        <div>
                            <el-button
                                class="clear-icon"
                                type="text"
                                @click="clearChatlist"
                            ></el-button>
                        </div>
                    </div>
                    <div class="chat-list">
                        <template v-for="(item, index) in chatlist">
                            <div
                                :key="item.id"
                                class="chat-box"
                                :class="{ 'selected-chat': item.current }"
                                @click="toggleCurrent(item)"
                                v-longtap="{ handler: longTap, time: 500 }"
                            >
                                <div class="chat-icon"></div>
                                <div class="chat-name" v-show="!item.showEditInput">
                                    {{ item.chat_name }}
                                </div>
                                <input
                                    class="inputBody"
                                    v-model="item.chat_name"
                                    v-show="item.showEditInput"
                                    ref="ipt"
                                />
                                <div
                                    class="two-icons edit-del-icons hidden max-sm:hidden"
                                    v-show="!item.showEditInput"
                                >
                                    <div class="flex flex-row">
                                        <div
                                            class="edit-icon"
                                            @click.stop="showInput(item, index)"
                                        ></div>
                                        <div class="h-[18px]">
                                            <el-button
                                                class="delete-icon"
                                                :id="item.id"
                                                type="text"
                                                @click.stop="delChat(item, index)"
                                            ></el-button>
                                        </div>
                                    </div>
                                </div>
                                <div class="two-icons" v-show="item.showEditInput">
                                    <div class="flex flex-row">
                                        <div
                                            class="save-icon"
                                            @click.stop="
                                                chatUpdate(item.chat_id, item.chat_name, index)
                                            "
                                        ></div>
                                        <div
                                            class="cancel-icon"
                                            @click.stop="hideUpdate(item)"
                                        ></div>
                                    </div>
                                </div>
                                <!--h5的编辑和删除是长按会话后显示在会话框下面-->
                                <div class="sm:hidden absolute top-[60px] right-0 z-10">
                                    <div class="childIcons hidden" ref="pop">
                                        <div class="h5-edit-icons">
                                            <div class="h5-icon">
                                                <el-button
                                                    class="edit-icon"
                                                    :id="item.id"
                                                    type="text"
                                                    @click.stop="doUpdateChat(item)"
                                                ></el-button>
                                            </div>
                                            <div
                                                class="w-px h-[30px] bg-[#C2C4CB]"
                                            ></div>
                                            <div class="h5-icon">
                                                <el-button
                                                    class="delete-icon"
                                                    :id="item.id"
                                                    type="text"
                                                    @click.stop="doDelChat(item)"
                                                ></el-button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
            </div>

            <!--移动端的历史会话和会话列表-->
            <div class="sm:hidden flex-1">
                <div class="history-chat-box">
                    <p class="history-chat">历史会话</p>
                    <div>
                        <el-button
                            class="clear-icon"
                            type="text"
                            @click="clearChatlist"
                        ></el-button>
                    </div>
                </div>
                <div class="chat-list">
                    <template v-for="(item, index) in chatlist">
                        <div
                            :key="item.id"
                            class="chat-box"
                            :class="{ 'selected-chat': item.current }"
                            @click="toggleCurrent(item)"
                            v-longtap="{ handler: longTap, time: 500 }"
                        >
                            <div class="chat-icon"></div>
                            <div class="chat-name" v-show="!item.showEditInput">
                                {{ item.chat_name }}
                            </div>
                            <input
                                class="inputBody"
                                v-model="item.chat_name"
                                v-show="item.showEditInput"
                                ref="ipt"
                            />
                            <div
                                class="two-icons edit-del-icons hidden max-sm:hidden"
                                v-show="!item.showEditInput"
                            >
                                <div class="flex flex-row">
                                    <div
                                        class="edit-icon"
                                        @click.stop="showInput(item, index)"
                                    ></div>
                                    <div class="h-[18px]">
                                        <el-button
                                            class="delete-icon"
                                            :id="item.id"
                                            type="text"
                                            @click.stop="delChat(item, index)"
                                        ></el-button>
                                    </div>
                                </div>
                            </div>
                            <div class="two-icons" v-show="item.showEditInput">
                                <div class="flex flex-row">
                                    <div
                                        class="save-icon"
                                        @click.stop="
                                            chatUpdate(item.chat_id, item.chat_name, index)
                                        "
                                    ></div>
                                    <div
                                        class="cancel-icon"
                                        @click.stop="hideUpdate(item)"
                                    ></div>
                                </div>
                            </div>
                            <!--h5的编辑和删除是长按会话后显示在会话框下面-->
                            <div class="sm:hidden absolute top-[60px] right-0 z-10">
                                <div class="childIcons hidden" ref="pop">
                                    <div class="h5-edit-icons">
                                        <div class="h5-icon">
                                            <el-button
                                                class="edit-icon"
                                                :id="item.id"
                                                type="text"
                                                @click.stop="doUpdateChat(item)"
                                            ></el-button>
                                        </div>
                                        <div
                                            class="w-px h-[30px] bg-[#C2C4CB]"
                                        ></div>
                                        <div class="h5-icon">
                                            <el-button
                                                class="delete-icon"
                                                :id="item.id"
                                                type="text"
                                                @click.stop="doDelChat(item)"
                                            ></el-button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
            
            <!-- <div class="recommend-service-box max-sm:hidden">
                <div class="recommend-service">
                    <p class="recomment-title">推荐服务</p>
                    <div class="flex flex-row justify-between">
                        <div class="one-service-box" @click="openAI(1)">
                            <div class="w-[60px] h-[60px] service-one"></div>
                            <p class="service-name">AI写作</p>
                        </div>
                        <div class="one-service-box" @click="openAI(2)">
                            <div class="w-[60px] h-[60px] service-two"></div>
                            <p class="service-name">论文查重</p>
                        </div>
                        <div class="one-service-box" @click="openAI(3)">
                            <div class="w-[60px] h-[60px] service-three"></div>
                            <p class="service-name">AI选刊</p>
                        </div>
                    </div>
                </div>
            </div>            -->
            <div class="new-chat sm:hidden">
                 <el-button :plain="true" class="new-chat-text" @click="addChat('')">新会话</el-button>
            </div>
        </div>
    </div>
</template>

<script>
import { nextTick } from "vue";
export default {
    props: ["sidebarShow", "isUpdate", 'changeOrder'],
    // isUpdate:更新侧边栏  changeOrder：改变侧边栏顺序
    data() {
        return {
            currentTab:'history', //当前tab
            chatlist: [], //会话列表
            showpop: false, //删除弹窗
            delchatid: 0, //删除的会话id
            chat_name: "", //会话名称

            showEditInput: false, //是否显示输入框和对钩叉号按钮
            arg: "",
			currentIndex: -1,
            isAdd: false, // 是否新增会话

            currentTool:{} // 当前工具

        };
    },
    watch: {
        isUpdate(newvalue) {
            if (newvalue) {
                this.showChatList();
            }
        },
        changeOrder: {
            handler(newvalue) {
                console.log(newvalue, '------------>')
                if (newvalue) {
                    let key;
                    for (let i = 0; i < this.chatlist.length; i++) {
                        if (this.chatlist[i].current == true) {
                            key = i
                            let fifthItem = this.chatlist[i]; // 获取第五项的值
                            this.chatlist.splice(i, 1); // 移除第五项
                            this.chatlist.unshift(fifthItem); // 将第五项插入到数组的第一个位置
                        }
                    }
                    console.log(key, '--------->')
                }
            },
            immediate: true,
            deep: true
        }
    },
    created(){
        // 切换 tool
        this.$bus.$on('toolHandler',(tool)=>{
            console.log( 'get', tool);
            this.currentTool = tool
            if (!this.currentTool.show_title) {
                this.currentTab = 'history'
            }else{
                this.currentTab = 'guide'
            }
            // 更新会话列表
            this.showChatList()

        })
        // 新增会话
        this.$bus.$on('addChat',(tool_id)=>{
            console.log('addChat',tool_id);
            this.addChat(tool_id)
        })
        // 更新会话列表 并通过 chat_id 切换会话
        this.$bus.$on('updateChatById',async (caht_id, promise=null)=>{
            const list =  await this.showChatList()
            console.log('chatList', list);
            const chatItem = this.chatlist.find(item=>{
                return item.chat_id == caht_id
            })
            chatItem.current = true
            console.log('chatItem', chatItem);
            this.$emit('handleClick', 'changeConversation', chatItem)
            promise ? promise.res() : ''
        })
    },
    mounted() {
        this.showChatList();
    },
    methods: {
        showChatList() { // 获取显示会话列表
            if (!this.currentTool.id) return
            let params = {
                token: window.localStorage.getItem("token"),
                tool_id: this.currentTool.id
            };
            console.log('chatList',params);
            return new Promise((resolve, rej)=>{
                this.$api.chatList(params).then(res=> {
                    if (res.data.length > 0) {
                        res.data.forEach((item, index) => {
                            item.showEditInput = false; //是否显示编辑框属性
                            if(this.isUpdate && index == 0) {
                                item.current = true;
                            } else {
                                item.current = false;
                            }
                        });
                        this.chatlist = res.data;
                        this.$emit('handleClick', 'updateStatus')
                        if (this.isAdd) {
                            this.$emit('handleClick', 'changeConversation', this.chatlist[0])
                            this.isAdd = false
                        }
                    } else {
                        this.chatlist = []
                    }
                    resolve(res)
                })

            })
        },
        //隐藏侧边栏
        hideSiderbarBox() {
            this.$emit("closeSiderbar");
        },

        //会话新增
        addChat(tool_id) {
            console.log(this.chatlist);
            let noneIndex = this.chatlist.findIndex((item,index)=>{
                return item.records.length == 0;
            })
            console.log(noneIndex);
            if (noneIndex != -1) {
                if(this.chatlist[noneIndex].current){
                    if(tool_id == 1){
                        this.$message({
                            message: '当前已是新会话，请提出你的问题',
                            type: 'warning',
                            center: true
                        });
                    }else{
                        this.$message({
                            message: '当前已是新会话！',
                            type: 'warning',
                            center: true
                        });
                    }
                    
                }else{
                    this.chatlist.forEach((i) => {
                        i.current = false;
                    });
                    this.chatlist[noneIndex].current = true;
                    console.log(this.chatlist);
                    this.$emit('handleClick', 'changeConversation', this.chatlist[noneIndex])
                }
            }else{
                let params = {
                    token: window.localStorage.getItem('token'),
                    chat_name: '',
                    tool_id: this.currentTool.id
                }
                this.$api.chatAdd(params).then(res=>{
                    console.log('add',res);
                    this.isAdd = true;
                    this.showChatList();
                    this.$emit("closeSiderbar");
                })
            }

        },

        
        //点击会话切换选中状态
        toggleCurrent(item) {
            this.currentIndex = -1
            this.chatlist.forEach((i) => {
                i.current = false;
            });
            item.current = true;
            this.$emit('handleClick', 'changeConversation', item)
            // return
            this.$emit("closeSiderbar"); //PC端切换会话也隐藏侧边栏
        },
        //展示输入框
        showInput(item, index) {
			this.chatlist[index].showEditInput = true;
            nextTick(() => {
                this.$refs.ipt[index].focus();
            });
            this.chatlist.forEach((i, key) => {
                if (item.id == i.id) {
                    this.chatlist[index].showEditInput = true;
                } else {
					this.chatlist[key].showEditInput = false;
				}
            });
        },
        //关闭输入框
        hideUpdate(item) {
            this.chatlist.forEach((i, index) => {
                if (item.id == i.id) {
                    this.chatlist[index].showEditInput = false;
                }
            });
        },
        //修改会话名称
        chatUpdate(chat_id, chat_name, index) {
            let datapost = {
                chat_id: chat_id,
                chat_name: chat_name,
                token: window.localStorage.getItem("token"),
            };
            //数据更新到后台
            this.$api.chatUpdate(datapost).then((res) => {
                //刷新,重新加载
                this.chatlist[index].chat_name = chat_name;
                this.chatlist[index].showEditInput = false;
            });
        },
        //删除会话
        delChat(item, index) {
            console.log(item);
            // return
            this.delchatid = item.chat_id;
            this.$confirm("会话删除后无法恢复，确定删除？", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                center: true,
            }).then(() => {
				//如果确认
				this.$api.chatDel(this.delchatid).then((res) => {
					console.log(res);
                    if (item.current) {
                        this.$emit('handleClick', 'changeConversation', { records:[] });
                        // this.$message.success('删除成功!');
                    }
                    this.chatlist.splice(index, 1)
				});
                this.$message({
                    type: 'success',
                    message: '删除成功!',
                    center: true
                });
			})
			.catch(() => {
				this.$message({
					type: "info",
					message: "已取消删除",
                    center: true
				});
			});
        },

        //H5端长按会话历史时,先显示独立出去的编辑和删除按钮
        //点击编辑,显示可输入弹窗,input默认显示会话名称,保存需要更新会话名称,取消则返回
        //点击删除,显示删除确认弹窗,选删除则删除,选取消则返回
        longTap(i, data, a) {
            this.hidePop();
            const firstChildElement = data.querySelector(".childIcons");
            if (firstChildElement.classList.contains("hidden")) {
                // 从元素的 classList 中删除指定的类名
                firstChildElement.classList.remove("hidden");
            }
        },
        //隐藏编辑和删除的小弹窗
        hidePop() {
            if (this.$refs.pop) {
                this.$refs.pop.forEach((item) => {
                    item.classList.add("hidden");
                });
            }
        },
        //点击编辑按钮后弹出弹窗
        doUpdateChat(item) {
            this.hidePop();
            let name = item.chat_name;
            this.$prompt("", {
                confirmButtonText: "保存",
                cancelButtonText: "取消",
                inputPlaceholder: "请输入你的问题",
                customClass: "h5UpdateBox",
                center: true,
            })
                .then(({ value }) => {
                    console.log(value);
                    item.chat_name = value;

                    let datapost = {
                        chat_id: item.chat_id,
                        chat_name: value,
                    };
                    //数据更新到后台
                    this.$api
                        .chatUpdate(datapost)
                        .then((res) => {})
                        .catch((msg) => {
                            // tip:修改失败
                            item.chat_name = name;
                        });
                    this.$message({
                        type: "success",
                        message: "你的问题是: " + value,
                    });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "取消输入",
                        center: true
                    });
                });
        },
        //会话删除
        doDelChat(item) {
            this.hidePop();
            this.delchatid = item.chat_id;
            this.$confirm("会话删除后无法恢复，确定删除？", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                center: true,
            })
                .then(() => {
                    //如果确认
                    this.$api.chatDel(this.delchatid).then((res) => {
                        console.log(res);
                        this.$emit('handleClick', 'changeConversation', { records: [] });
                    });
                    // this.delchatid = 0
                    this.chatlist = this.chatlist.filter((i) => {
                        return i.chat_id != item.chat_id;
                    });
                    //刷新,重新加载列表
                    this.showChatList();
                    this.$message({
                        type: "success",
                        message: "删除成功!",
                        center: true
                    });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除",
                        center: true
                    });
                });
        },
        //会话清空
        clearChatlist() {
            this.$confirm("清空历史会话？", {
                confirmButtonText: "清空",
                cancelButtonText: "取消",
                // type: 'warning'
                center: true,
            })
                .then(() => {
                    //如果确认
                    console.log(this);
                    this.chatlist = [];

                    this.$api
                        .chatClear({
                            tool_id: this.currentTool.id
                        })
                        .then((res) => {
                            this.$emit('handleClick', 'clear');
                            this.chatlist = [];
                            this.$message({
                                type: "success",
                                message: "清空成功!",
                                center: true
                            });
                        })
                        .catch((msg) => {
                            console.log("清空失败");
                        });

                    //刷新,重新加载列表
                    // this.showChatList();
                })
                .catch(() => {
                    console.log(890);
                    this.$message({
                        type: "info",
                        message: "已取消清空",
                        center: true
                    });
                });
        },
        //打开链接
        // openAI(type){
        //     switch (type) {
        //         case 0:
        //             window.location.reload('')
        //             break;
        //         case 1:
        //             //window.location.href = 'https://sci.medlive.cn/ai-write'
        //             window.open('https://sci.medlive.cn/ai-write', '_blank')
        //             break;
        //         case 2:
        //             // window.location.href = 'https://sci.medlive.cn/thesis/submit'
        //             window.open('https://sci.medlive.cn/thesis/submit', '_blank')
        //             break;
        //         case 3:
        //             // window.location.href = 'https://sci.medlive.cn/intellect/index'
        //             window.open('https://sci.medlive.cn/intellect/index', '_blank')
        //             break;
        //         default:
        //             break;
        //     }
        // }
    },
};
</script>

<style lang="scss" scoped>
.siderbar-box {
    @apply max-sm:w-full h-full absolute top-0 max-sm:right-0 sm:left-[0] z-20;
    .shadow-box {
        background: rgba(0, 0, 0, 0.5);
        @apply fixed sm:relative top-0 bottom-0 w-full h-full;
    }
    .siderbar-body {
        @apply fixed top-0 sm:relative w-[277px] sm:w-[358px] h-full sm:px-9 sm:py-12 max-sm:px-4 max-sm:py-5 flex flex-col gap-y-2 sm:left-0 bg-white sm:border-r border-[#C2C4CB];
        .closeSiderbarBtn{
            @apply absolute right-2 top-1 w-5 h-5 cursor-pointer;
        }
        .new-chat {
            @apply w-full h-14 mb-5 px-4 bg-[#FAF9F9] sm:bg-white rounded-[15px] cursor-pointer mt-5 sm:mt-12;
            .new-chat-text {
                background: url(@/assets/icon_add_chat.png) no-repeat left 16px;
                background-size: 22px 22px;
                padding-left: 30px;
                border: none !important;
                @apply w-full text-left h-14 text-base leading-[36px] py-[10px] text-[#333333];
                &:hover{
                    color: #333333 !important;
                }
            }
        }
        .history-chat-box {
            border-bottom: 1px solid #c2c4cb;
            @apply flex flex-row justify-between;
            .history-chat {
                @apply pb-1 text-sm text-[#A0A3AE] cursor-pointer;
            }
            .clear-icon {
                background: url(@/assets/icon_delete.png) no-repeat;
                background-size: 18px 18px;
                @apply w-[18px] h-[18px] mb-1;
            }
        }
        .chat-list {
            @apply flex-1 flex flex-col items-center gap-y-2 py-2 overflow-hidden;
            &:hover{
                @apply overflow-y-auto;
            }
            .chat-box {
                @apply relative w-full flex justify-between items-center py-[11px]  sm:hover:bg-white rounded-[15px] select-none cursor-pointer;
                &:hover .edit-del-icons, &.selected-chat:hover .edit-del-icons {
                    @apply sm:flex;
                }
                .chat-icon {
                    @apply w-[18px] h-[18px] mt-px ml-2.5 mr-2;
                    background: url(@/assets/icon_chat.png) no-repeat;
                    background-size: 100% auto;
                }
                .chat-name {
                    @apply flex-1 text-sm overflow-hidden text-[#333333] whitespace-nowrap text-ellipsis;
                }
                .inputBody {
                    outline: none;
                    @apply text-sm min-w-0 p-0 rounded-md border-none bg-transparent flex-1;
                }
                .two-icons {
                    @apply w-14 mt-px mr-[18px];
                    .edit-icon {
                        @apply w-[18px] h-[18px] ml-2.5;
                        background: url(@/assets/icon_edit_c.png) no-repeat;
                        background-size: 100% auto;
                    }
                    .delete-icon {
                        @apply w-[18px] h-[18px] ml-2.5 p-0;
                        background: url(@/assets/icon_delete_c.png) no-repeat;
                        background-size: 100% auto;
                    }
                    .save-icon {
                        @apply w-[18px] h-[18px] ml-2.5;
                        background: url(@/assets/icon_save.png) no-repeat;
                        background-size: 100% auto;
                    }
                    .cancel-icon {
                        @apply w-[18px] h-[18px] ml-2.5;
                        background: url(@/assets/icon_cancel.png) no-repeat;
                        background-size: 100% auto;
                    }
                }
                &:hover, &.selected-chat{
                    @apply sm:bg-[#F6F9FE];
                    .chat-icon {
                        background: url(@/assets/icon_chat_c.png) no-repeat;
                        background-size: 100% auto;
                    }
                    .chat-name, .inputBody{
                        @apply text-[#4C5BDF];
                    }
                    .edit-icon {
                        background: url(@/assets/icon_edit_c.png) no-repeat;
                        background-size: 100% auto;
                    }
                    .delete-icon {
                        background: url(@/assets/icon_delete_c.png) no-repeat;
                        background-size: 100% auto;
                    }
                    .save-icon {
                        background: url(@/assets/icon_save_c.png) no-repeat;
                        background-size: 100% auto;
                    }
                    .cancel-icon {
                        background: url(@/assets/icon_cancel_c.png) no-repeat;
                        background-size: 100% auto;
                    }
                }
                // &.selected-chat{
                //     .edit-del-icons {
                //          @apply sm:hidden;
                //     }
                // }
                .h5-edit-icons {
                    @apply flex flex-row justify-center items-center bg-[#FAF9F9] rounded-[10px];
                    .h5-icon {
                        @apply px-[15px] py-4;
                        .edit-icon {
                            @apply p-0 w-[18px] h-[18px];
                            background: url(@/assets/icon_edit.png) no-repeat;
                            background-size: 100% auto;
                        }
                        .delete-icon {
                            @apply p-0 w-[18px] h-[18px];
                            background: url(@/assets/icon_delete.png) no-repeat;
                            background-size: 100% auto;
                        }
                    }
                }
            }
        }
        .recommend-service-box{
            @apply  pt-[30px] border-t border-solid border-[#C2C4CB];
            .recommend-service {
                @apply w-[294px] bg-white p-5 rounded-[15px] text-center;
                .recomment-title {
                    @apply mb-[15px] text-base text-[#333333];
                }
                .one-service-box {
                    @apply w-[60px] text-center cursor-pointer;
                    .service-one {
                        background: url(@/assets/service1.png) no-repeat;
                        background-size: 100% auto;
                    }
                    .service-two {
                        background: url(@/assets/service2.png) no-repeat;
                        background-size: 100% auto;
                    }
                    .service-three {
                        background: url(@/assets/service3.png) no-repeat;
                        background-size: 100% auto;
                    }
                    .service-name {
                        @apply text-xs text-[#616474] mt-1;
                    }
                }
            }
        }     
        //操作指引和历史会话
        .guide-history-top{
            @apply flex flex-row justify-start items-center mb-5 border-b border-[#C2C4CB];
            .guide-btn{
                @apply mr-7 pb-3 text-sm text-[#A0A3AE] leading-5 cursor-pointer relative;
                &.active{
                    @apply text-[#4C5BDF] font-bold border-[#4C5BDF];
                    &:after{
                        content: '';
                        @apply w-full h-[1px] bg-[#4C5BDF] rounded-sm absolute bottom-[-1px] left-0;
                    }
                }
            }
        }
        .blue-new-chat{
            @apply bg-[#4C5BDF];
            .new-chat-text {
                @apply text-white;
                background: url(@/assets/icon_add_chat1.png) no-repeat left 16px;
                background-size: 22px 22px;
                &:hover{
                    color: white !important;
                }
            }
        }
        //操作指引
        .guide-cont{
            background: linear-gradient(180deg, rgba(240, 241, 255, 0.8) 0%, rgba(246, 249, 254, 0.29) 100%);
            @apply w-full h-[430px] pt-4 rounded-[15px];
            .guide-title{
                @apply pb-3 text-[#444444] text-xs text-center border-b-[0.5px] border-[#C2C4CB];
            }
            .guide-step-list{
                @apply mt-[0.5px] pt-6 px-[22px] border-t-[0.5px] border-[#FFFFFF];
                .guide-step{
                    @apply flex flex-row justify-start items-start mb-[14px] text-[#444444] text-sm;
                    .step-icon{
                        @apply w-[6px] h-16 mt-[7px] mr-[6px];
                        background: url(@/assets/icon_step.png) no-repeat;
                        background-size: 100% auto;
                    }
                    &:last-child{
                        .step-icon{
                            background: url(@/assets/icon_step_last.png) no-repeat;
                            background-size: 100% auto;
                        }
                    }
                    .step-cont{
                        .step-title{
                            @apply mb-3 text-[#4C5BDF] text-sm leading-[22px];
                            label{
                                @apply ml-[2px] font-bold opacity-[0.3];
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>